module.exports = __webpack_public_path__ + "img/2023-01.18f919d4.jpg";